// common_function.ts is the common function file
// use for re-use all the functions

export const createPublicChannel = (doctorId,attendeeId) => {
    let chnlArr = [];
    if(doctorId != "" && doctorId != null && attendeeId != "" && attendeeId != null){
        chnlArr[0] = attendeeId.split(".").join("-");
        chnlArr[1] = doctorId.split(".").join("-");
        let channel = chnlArr.sort().join("-")
        return channel;
    }else{
        return ""
    }
}

export const createCipherKey = (title) => {
	return "cipher-key" + '-' + title;
}
